import React from 'react';
import styled from 'styled-components';

import TimePicker from '../../TimePicker';
import Icon from '../../Icon';

const STimePicker = styled((props) => (
  <TimePicker
    clearIcon={null}
    use12Hours={props.use12Hours}
    suffixIcon={() => <Icon icon="date" />}
    showNow={false}
    minuteStep={30}
    format="HH:mm"
    popupStyle={{
      zIndex: 9999,
    }}
    {...props}
  />
))`
  border: ${(props) =>
    props.isError ? `1px solid ${props.theme.palette.colors.red100}` : null};
  border-radius: 5px;
  margin-right: ${(props) => props.marginRight};
  min-height: ${({ isBig }) => (isBig ? '40px' : '32px')};

  input::placeholder {
    font-weight: 500;
    font-size: 16px;
    color: ${// @ts-ignore
    ({ theme }) => theme.palette.colors.gray400};
  }

  //.ant-picker-suffix {
  //  position: absolute;
  //  left: 0;
  //  color: black;
  //}
  .ant-picker:hover {
    border: ${(props) =>
      props.isError
        ? `1px solid ${props.theme.palette.colors.red100}`
        : `1px solid ${props.theme.palette.colors.blue100}`};
  }
`;

export default STimePicker;
